import { Box } from "@mui/material";
import HeaderComponent from "./header-component";
import FooterComponent from "./footer-component";
import PropTypes from "prop-types";

const ErrorLayout = ({ children,isError }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header (fixed height) */}
      <HeaderComponent  isError={isError}   
      />

      {/* Body Section */}
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          overflow: "hidden",
        }}
      >      

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            position: "relative",
            overflowY: "auto",
            px: 2,
            pt: { xs: 14, sm: 12, md: 12 }, 
            pb: 3  
          }}
        >
          {children}
        </Box>
      </Box>

      {/* Footer */}
      <FooterComponent />
    </Box>
  );
};

export default ErrorLayout;

ErrorLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isError: PropTypes.bool,
};
